/**
 * Product Swatch Hover - Pre-loads images for instant switching
 */
const isMobile = () => window.matchMedia('(max-width: 768px)').matches || 'ontouchstart' in window;

function initProductSwatchHover(container = document) {
  container.querySelectorAll('[data-product-image]').forEach(swatchLi => {
    const swatch = swatchLi.tagName === 'A' ? swatchLi : swatchLi.querySelector('a[href]');
    if (!swatch) return;
    
    const wrapper = swatchLi.closest('.product-card__wrapper');
    const imageWrapper = isMobile() 
      ? wrapper?.querySelector('.media-wrapper.product-card__image--main') || wrapper?.querySelector('.product-card__image-wrapper')
      : wrapper?.querySelector('.product-card__image-wrapper');
    
    const dataElement = swatchLi.hasAttribute('data-product-image') ? swatchLi : swatch;
    const { productImage: imageSrc, swatchId, productTags = '', option = '' } = dataElement.dataset;
    const variantUrl = swatch.href !== 'undefined' ? swatch.href : null;
    
    if (!wrapper || !imageWrapper || !imageSrc || !swatchId) return;
    
    // Cache DOM elements
    const colorLabel = wrapper.querySelector('[data-color-label]');
    const allSwatches = wrapper.querySelectorAll('[data-product-image]');
    
    // Main card image link - retargeted while a swatch is previewed
    const imageLink = imageWrapper.querySelector('a[href]');
    if (imageLink && !imageLink.dataset.defaultHref) {
      imageLink.dataset.defaultHref = imageLink.getAttribute('href');
    }

    // Unified state management
    const setState = (active, colorName = null) => {
      // Clear all states first
      allSwatches.forEach(s => s.classList.remove('swatch-selected'));
      wrapper.querySelectorAll('.product-card__swatch-image').forEach(img => img.classList.remove('active'));

      if (imageLink) {
        imageLink.setAttribute('href', active && variantUrl ? variantUrl : imageLink.dataset.defaultHref);
      }

      if (active) {
        // Activate current swatch and image
        dataElement.classList.add('swatch-selected');
        imageWrapper.querySelector(`[data-swatch="${swatchId}"]`)?.classList.add('active');
        wrapper.classList.add('swatch-hover');
      } else {
        wrapper.classList.remove('swatch-hover');
      }
      
      if (colorLabel) {
        if (active && colorName) {
          colorLabel.textContent = colorName;
        } else if (!active && colorLabel.dataset.originalColor) {
          colorLabel.textContent = colorLabel.dataset.originalColor;
        }
      }
    };
    
    // Get color name from tags or format option
    const getColorName = () => {
      const tags = productTags.split(',');
      
      // First, try to find WebColorName_ tag
      const webColorNameTag = tags.find(tag => {
        const hasWebColorName = tag.includes('WebColorName_');
        
        if (hasWebColorName) {
          const tagName = tag.replace('WebColorName_', '').trim();
          
          // If option exists, try to match
          if (option) {
            const match1 = tag.toLowerCase().includes(option.toLowerCase());
            const match2 = option.toLowerCase().includes(tagName.toLowerCase());
            return match1 || match2;
          } else {
            // If no option, return first WebColorName_ found
            return true;
          }
        }
        return false;
      });
      
      // If WebColorName_ found, use it
      if (webColorNameTag) {
        return webColorNameTag.replace('WebColorName_', '').trim();
      }
      
      // Fallback: Look for WebColor_ tag
      const webColorTag = tags.find(tag => tag.includes('WebColor_'));
      
      if (webColorTag) {
        const colorValue = webColorTag.replace('WebColor_', '').trim();
        // Format WebColor_ value: "SLATE GREY" → "Slate Grey"
        return colorValue
          .toLowerCase()
          .split(/[\s_-]+/)
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      }
      
      // Final fallback: Format option if available
      if (option) {
        return option.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase().split(/[\s_-]+/)
          .map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      }
      
      return '';
    };
    
    // Pre-load image
    if (!imageWrapper.querySelector(`[data-swatch="${swatchId}"]`)) {
      const img = Object.assign(document.createElement('img'), {
        src: imageSrc,
        className: 'product-card__swatch-image',
        alt: swatch.dataset.title,
        title: swatch.dataset.title
      });
      img.dataset.swatch = swatchId;
      imageWrapper.appendChild(img);
    }
    
    // Event handlers
    if (isMobile()) {
      swatch.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setState(true, getColorName());
        if (variantUrl) wrapper.dataset.selectedVariantUrl = variantUrl;
      };
    } else {
      swatch.onmouseenter = () => setState(true, getColorName());
      swatch.onmouseleave = () => setState(false);
      // Keyboard parity with hover
      swatch.onfocus = () => setState(true, getColorName());
      swatch.onblur = () => setState(false);
    }
  });
}

// Make function globally accessible
window.initProductSwatchHover = initProductSwatchHover;

// Handle mobile card clicks for selected variants
function handleCardClick(e) {
  if (!isMobile()) return;
  
  const card = e.target.closest('.product-card__wrapper');
  const selectedUrl = card?.dataset.selectedVariantUrl;
  
  if (!selectedUrl || selectedUrl === 'undefined') return;
  
  // Skip if clicked on interactive elements
  const skipSelectors = '[data-product-image], button, .product-card__actions, .swatch-color';
  if (e.target.closest(skipSelectors)) return;
  
  e.preventDefault();
  window.location.href = selectedUrl;
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  initProductSwatchHover();
  document.addEventListener('click', handleCardClick);
});
document.addEventListener('shopify:section:load', e => initProductSwatchHover(e.target));